import { Injectable } from '@angular/core';
import {compileComponentClassMetadata} from "@angular/compiler";
import {Params} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ParameterService {
    private parameters: Params = {};

    public add( params: Object ) {
        this.parameters = params;
    }
    public get() {
        return this.parameters;
    }
    public clear() {
        this.parameters = {};
    }
}
